(function($) {

  var check = $('.block-moviecarousel').length;

  if(!check) return;

  var movie1 = new Swiper('.block-moviecarousel .swiper-container.movie-images', {
    grabCursor: true,
    spaceBetween: 60,
    centeredSlides: true,
    slidesPerView: 1,
    autoHeight: false,
    breakpoints: {
      576: {
        slidesPerView: 1.125,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 1.25,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
      1400: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
      1500: {
        slidesPerView: 1.75,
        spaceBetween: 60,
      },
    }
  });

  var movie2 = new Swiper('.block-moviecarousel .swiper-container.movie-content', {
    slidesPerView: 1,
    autoHeight: false,
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // 576: {
      //   spaceBetween: 30,
      // },
      // 1024: {
      //   spaceBetween: 30,
      // },
      // 1400: {
      //   spaceBetween: 40,
      // },
      // 1500: {
      //   spaceBetween: 40,
      // },
    }
  });

  movie1.controller.control = movie2;
  movie2.controller.control = movie1;


})(jQuery);